


























































import {Prop, Watch} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import {Achat, DestType, EssenceAchat, Livraison, Token} from "@/models";
import {InOut} from "vue-inout-prop-decorator/index";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudLivraisonEditDialog from "@/components/Crud/Livraison/EditDialog.vue";
import storeLivraison from "@/stores/modules/livraison";
import storeAchat from "@/stores/modules/achat";
import {Stored} from "vue-stored-prop-decorator/index";
import storeEssenceAchat from "@/stores/modules/essenceAchat";

@Component({
	components: {
		CrudDeleteDialog,
		CrudLivraisonEditDialog,
	}
})
export default class CrudLivraisonListLivraison extends Vue {

	private editLivraison: Livraison = null;
	private deletedLivraison: Livraison = null;
	private storeLivraison = storeLivraison;
	@Stored(() => storeAchat)
		private achat: Achat;
	@Stored(() => storeEssenceAchat)
	private essence: EssenceAchat;
	@InOut({ type: EssenceAchat  , isVModel: true }) private value!: EssenceAchat;

	public constructor() {
		super();
	}

	private headers = [
		{
			text: 'Date de livraison',
			value: 'date',
		},
		{ text: 'Destination', value: 'destination' },
		{ text: 'Volume', value: 'volume' },
		{ text: 'Transporteur', value: 'transporteur' },
		{ text: 'Chauffeur', value: 'chauffeur' },
		{ text: 'Remarques', value: 'remarques' },
		
		{ text: 'Actions', value: 'action' },
	];

	private onDeleteLivraison(): void {
		this.value.livraisons.splice(this.value.livraisons.findIndex(v => v.id == this.deletedLivraison.id), 1);
	}


	private async onCancelLivraison(): Promise<void> {
		await storeAchat.dispatch('get', this.achat.id);
		if (this.achat.essenceAchats) {
			for (const essence of this.achat.essenceAchats) {
				if (essence.id == this.value.id) {
					this.value = essence;
				}
			}
		}
	}

	private async onEditLivraison(livraison: Livraison): Promise<void> {
		// await storeAchat.dispatch('get', this.achat.id);
	}
}
